// @flow

import styled, { css } from 'styled-components';
import { media } from '../../../helpers';
import type { Theme } from '../../../types';

export default styled<any, Theme>('div')`
  max-width: 48rem;
  margin: 0 auto;
  padding: 1rem;
  ${media.md(css`
    padding: 2rem 1rem;
  `)}
  ${media.lg(css`
    padding: 3rem 1rem;
  `)}
`;
